import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { GLOSSARY } from "@/data/glossaryData";
import { LOGO_URL } from "@/config";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { BookMarked } from "lucide-react";

const SITE = "https://creatara.ai";

export default function GlossaryIndexPage() {
  const definedTermSetSchema = {
    "@context": "https://schema.org",
    "@type": "DefinedTermSet",
    name: "Creatara Glossary",
    url: `${SITE}/glossary`,
    hasDefinedTerm: GLOSSARY.map((e) => ({
      "@type": "DefinedTerm",
      name: e.term,
      description: e.summary,
      url: `${SITE}/glossary/${e.slug}`,
    })),
  };

  return (
    <>
      <Helmet>
        <title>Glossary: AI Content, GEO & Monetisation Terms | Creatara</title>
        <meta name="description" content="Plain-English definitions for AI content marketing, GEO citation tracking, the Monetisation Score, affiliate tracking, and lead capture forms." />
        <link rel="canonical" href={`${SITE}/glossary`} />
        <meta property="og:title" content="Creatara Glossary" />
        <meta property="og:description" content="Definitions for AI content marketing and GEO terms." />
        <script type="application/ld+json">{JSON.stringify(definedTermSetSchema)}</script>
      </Helmet>

      <div className="min-h-screen bg-background">
        <nav className="fixed top-0 w-full z-50 glass">
          <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Creatara" className="w-10 h-10 rounded-lg" />
              <span className="font-bold text-lg">Creatara</span>
            </Link>
            <Link to="/auth"><Button size="sm" className="rounded-full bg-violet-600 hover:bg-violet-700">Try Free</Button></Link>
          </div>
        </nav>

        <div className="max-w-4xl mx-auto px-6 pt-32 pb-20" data-testid="glossary-index">
          <Badge variant="secondary" className="mb-3"><BookMarked className="w-3 h-3 mr-1" /> Glossary</Badge>
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">Glossary</h1>
          <p className="text-lg text-muted-foreground max-w-2xl mb-12">Plain-English definitions for AI content marketing, GEO citation tracking, and the workflow terms used inside Creatara.</p>

          <div className="space-y-3">
            {GLOSSARY.map((e) => (
              <Link key={e.slug} to={`/glossary/${e.slug}`} className="block rounded-lg bg-white/5 border border-white/10 hover:border-violet-500/40 p-5" data-testid={`glossary-card-${e.slug}`}>
                <p className="font-bold text-lg mb-1">{e.term}</p>
                <p className="text-sm text-muted-foreground line-clamp-2">{e.summary}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
